export default function () {
    return {
        require: 'ngModel',
        link: function (scope, element, attrs, modelCtrl) {
            element.bind('keypress', function (event) {
                let ASCII_MIN_DIGIT = 48;
                let ASCII_MAX_DIGIT = 57;
                let BACKSPACE = 8;
                let ENTER = 13;

                let keyCode = event.keyCode || event.charCode;

                if ((keyCode < ASCII_MIN_DIGIT || keyCode > ASCII_MAX_DIGIT)
                    && keyCode !== BACKSPACE
                    && keyCode !== ENTER
                ) {
                    event.preventDefault();
                }

            });
        }
    };
};